import _get from 'lodash/get';
import defaultFlags from '../initFlags/featureFlags';

const defaultPeFlag = _get(defaultFlags, 'flags.peFlag', 'ON');
const defaultFleekAudioIsUnMuted = _get(defaultFlags, 'flags.fleekAudioIsUnMuted', 'ON');
const defaultPickFromStoreFlag = _get(defaultFlags, 'flags.pickFromStoreFlag', 'ON');
const defaultShowStorePickUpTab = _get(defaultFlags, 'flags.showStorePickUpTab', 'ON');
const defaultDropAtStoreFlag = _get(defaultFlags, 'flags.dropAtStoreFlag', 'ON');
const defaultCODCustomMessage = _get(defaultFlags, 'flags.codCustomMessage', '');

const defaultPickFromStoreBanner = _get(
  defaultFlags,
  'flags.pickFromStoreBanner',
  'Please note this service is available in select Trends stores in select cities across India.'
);
const defaultDropAtStoreBanner = _get(
  defaultFlags,
  'flags.dropAtStoreBanner',
  'Available only at Trends stores in Bangalore'
);
const defaultChatWithUsFlag = _get(defaultFlags, 'flags.chatWithUsFlag', 'OFF');
const defaultCallMeBackFlag = _get(defaultFlags, 'flags.callMeBackFlag', 'OFF');
const defaultMarkAsDeliverdFlag = _get(defaultFlags, 'flags.markAsDeliveredFlag', 'OFF');
const defaultHaptikInitSettings = _get(defaultFlags, 'flags.haptikInitSettings', {});
const defaultHaptikSrcUrl = _get(
  defaultFlags,
  'flags.haptikSrcUrl',
  'https://toolassets.haptikapi.com/platform/javascript-xdk/production/loader.js'
);
const defaultPlpSizesFlag = _get(defaultFlags, 'flags.plpSizesFlag', 'ON');
const defaultEnableCatNavSec = _get(defaultFlags, 'flags.enableCatNavSec', 'ON');
const defaultJewelReturnMessageFlag = _get(defaultFlags, 'flags.jewelReturnMessageFlag', 'OFF');
const defaultJewelReturnModalMessage = _get(defaultFlags, 'flags.jewelReturnModalMessage', '');
const defaultNewSizeRevampFlag = _get(defaultFlags, 'flags.newSizeRevampFlag', 'ON');
const defaultShowBrandSizeFlag = _get(defaultFlags, 'flags.showBrandSizeFlag', 'ON');
const defaultNewSizeRevampDesktopFlag = _get(defaultFlags, 'flags.newSizeRevampDesktopFlag', 'OFF');
const defaultShowBrandSizeDesktopFlag = _get(defaultFlags, 'flags.showBrandSizeDesktopFlag', 'OFF');
const defaultSizeRecommendFlag = _get(defaultFlags, 'flags.sizeRecommendFlag', 'OFF');
const defaultSizeRecommendAppFlag = _get(defaultFlags, 'flags.sizeRecommendAppFlag', 'ON');
const defaultShowOtpMessageForMobile = _get(defaultFlags, 'flags.otp_popup_display_mobile', true);
const defaultShowOtpMessageForEmail = _get(defaultFlags, 'flags.otp_popup_display_email', false);

//  Customer Care Default Values Settings
const defaultShowCustomerCareContactNumberFlag = _get(
  defaultFlags,
  'flags.showCustomerCareContactNumber',
  'ON'
);
const defaultShowCustomerCareEmailIdFlag = _get(
  defaultFlags,
  'flags.showCustomerCareEmailId',
  'ON'
);
const defaultCustomerCareEmailId = _get(
  defaultFlags,
  'flags.customerCareEmailId',
  'customercare@ajio.com'
);
const defaultCustomerCareMobileNumber = _get(
  defaultFlags,
  'flags.customerCareContactNumber',
  '1800-889-9991'
);
const defaultWrongProductDeliveredOptions = _get(
  defaultFlags,
  'flags.wrongProductDeliveredOptions',
  [
    {
      reason: 'Wrong Item Shipped',
      subReasons: ['Wrong Color Delivered', 'Delivered wrong size']
    }
  ]
);

const defaultSiteNameToFindIfscCode = _get(defaultFlags, 'flags.siteNameToFindIfscCode', 'RBI');
const defaultSiteUrlToFindIfscCode = _get(
  defaultFlags,
  'flags.siteUrlToFindIfscCode',
  'https://www.rbi.org.in/Scripts/IFSCMICRDetails.aspx'
);
const defaultBlockNotFoundIfscCodeSubmit = _get(
  defaultFlags,
  'flags.blockNotFoundIfscCodeSubmit',
  'OFF'
);

const defaultShowReOpenComplaintFormFlag = _get(
  defaultFlags,
  'flags.showReOpenComplaintFormFlag',
  'OFF'
);
const defaultUsps = _get(defaultFlags, 'flags.usps', [
  'Assured Quality',
  '100% Handpicked',
  'Easy Exchange'
]);

const defaultCustomerCareEmailResponseTime = _get(
  defaultFlags,
  'flags.cc_email_response_time_message',
  'Response in 24 hours'
);

const defaultDisableGSTContentFlag = _get(defaultFlags, 'flags.disableGSTContent', '');
const defaultGSTMessage = _get(defaultFlags, 'flags.defaultGSTMessage', '');
const defaultShowCallMeBackForLuxuryOrder = _get(
  defaultFlags,
  'flags.showCallMeBackForLuxuryOrder',
  'OFF'
);
const defaultShowCarrierInfo = _get(defaultFlags, 'flags.showCarrierInfo', 'ON');
const defaultOrderFilterFlag = _get(defaultFlags, 'flags.orderFilterFlag', 'ON');

const defaultLuxuryOrderFlag = _get(defaultFlags, 'flags.luxuryOrderFlags', {});
const defaultEstimatedWaitTimeCMB = _get(defaultFlags, 'flags.estimatedWaitTimeCMB', 'ON');
const defaultShowTimeSlotsCMB = _get(defaultFlags, 'flags.showTimeSlotsCMB', 'ON');
const defaultScNextQuestionInSecs = _get(defaultFlags, 'flags.showScNextQuestionInSecs', 3);
const defaultPaymentMsg = _get(defaultFlags, 'flags.paymentMsg', '');
const defaultHurryMsgInvCap = _get(defaultFlags, 'flags.hurryMsgInvCap', 10);
const defaultSelfShipCredit = _get(defaultFlags, 'flags.returnCapture.selfShipCredit', 150);
const defaultSelfShipMsg = _get(
  defaultFlags,
  'flags.returnCapture.selfShipMsg',
  'This is a Self Ship request. After placing the request, please send the below product(s) to our address.'
);

export const getCustomCODMessage = flags =>
  _get(flags, 'codCustomMessage', defaultCODCustomMessage);

export const getPeFlag = flags => _get(flags, 'peFlag', defaultPeFlag) === 'ON';
export const getFleekAudioIsUnMuted = flags =>
  _get(flags, 'fleekAudioIsUnMuted', defaultFleekAudioIsUnMuted) === 'ON';

export const getPickFromStoreFlag = flags =>
  _get(flags, 'pickFromStoreFlag', defaultPickFromStoreFlag) === 'ON';

export const getShowStorePickUpTab = flags =>
  _get(flags, 'showStorePickUpTab', defaultShowStorePickUpTab) === 'ON';

export const getDropAtStoreFlag = flags =>
  _get(flags, 'dropAtStoreFlag', defaultDropAtStoreFlag) === 'ON';

export const getPickFromStoreBanner = flags => {
  const tempBanner = _get(flags, 'pickFromStoreBanner', defaultPickFromStoreBanner);
  return tempBanner === 'OFF' ? false : tempBanner;
};

export const getDropAtStoreBanner = flags => {
  const tempBanner = _get(flags, 'dropAtStoreBanner', defaultDropAtStoreBanner);
  return tempBanner === 'OFF' ? false : tempBanner;
};

export const getChatWithUsFlag = flags =>
  _get(flags, 'chatWithUsFlag', defaultChatWithUsFlag) === 'ON';

export const getCallMeBackFlag = flags =>
  _get(flags, 'callMeBackFlag', defaultCallMeBackFlag) === 'ON';

export const getMarkAsDeliveredFlag = flags =>
  _get(flags, 'markAsDeliveredFlag', defaultMarkAsDeliverdFlag) === 'ON';

export const getHaptikInitSettings = flags => {
  const haptikSettings = _get(flags, 'haptikInitSettings', defaultHaptikInitSettings);
  if (typeof haptikSettings === 'object') {
    return JSON.stringify(haptikSettings);
  }
  return haptikSettings;
};
export const getHaptikSrcUrl = flags => _get(flags, 'haptikSrcUrl', defaultHaptikSrcUrl);

export const getPlpSizesFlag = flags => _get(flags, 'plpSizesFlag', defaultPlpSizesFlag) === 'ON';

export const getEnableCatNavSec = flags =>
  _get(flags, 'enableCatNavSec', defaultEnableCatNavSec) === 'ON';

export const getjewelReturnMessageFlag = flags =>
  _get(flags, 'jewelReturnMessageFlag', defaultJewelReturnMessageFlag) === 'ON';

export const getjewelReturnModalMessage = flags =>
  _get(flags, 'jewelReturnModalMessage', defaultJewelReturnModalMessage);

export const getNewSizeRevampFlag = flags =>
  _get(flags, 'newSizeRevampFlag', defaultNewSizeRevampFlag) === 'ON';

export const getNewSizeRevampDesktopFlag = flags =>
  _get(flags, 'newSizeRevampDesktopFlag', defaultNewSizeRevampDesktopFlag) === 'ON';

export const getShowBrandSizeDesktopFlag = flags =>
  _get(flags, 'showBrandSizeDesktopFlag', defaultShowBrandSizeDesktopFlag) === 'ON';

export const getShowOtpMessageForMobile = flags =>
  _get(flags, 'otp_popup_display_mobile', defaultShowOtpMessageForMobile);
export const getShowOtpMessageForEmail = flags =>
  _get(flags, 'otp_popup_display_email', defaultShowOtpMessageForEmail);

export const getShowCustomerCareContactNumberFlag = flags =>
  _get(flags, 'showCustomerCareContactNumber', defaultShowCustomerCareContactNumberFlag) === 'ON';

export const getShowCustomerCareEmailIdFlag = flags =>
  _get(flags, 'showCustomerCareEmailId', defaultShowCustomerCareEmailIdFlag) === 'ON';

export const getCustomerCareEmailId = flags =>
  _get(flags, 'customerCareEmailId', defaultCustomerCareEmailId);

export const getCustomerCareMobileNumber = flags =>
  _get(flags, 'customerCareContactNumber', defaultCustomerCareMobileNumber);

export const getShowBrandSizeFlag = flags =>
  _get(flags, 'showBrandSizeFlag', defaultShowBrandSizeFlag) === 'ON';

export const getWrongProductDeliveredOptions = flags =>
  _get(flags, 'wrongProductDeliveredOptions', defaultWrongProductDeliveredOptions);

export const getSizeRecommendFlag = flags =>
  _get(flags, 'sizeRecommendFlag', defaultSizeRecommendFlag) === 'ON';

export const getSizeRecommendAppFlag = flags =>
  _get(flags, 'sizeRecommendAppFlag', defaultSizeRecommendAppFlag) === 'ON';

export const getSiteNameToFindIfscCode = flags =>
  _get(flags, 'siteNameToFindIfscCode', defaultSiteNameToFindIfscCode);

export const getSiteUrlToFindIfscCode = flags =>
  _get(flags, 'siteUrlToFindIfscCode', defaultSiteUrlToFindIfscCode);

export const getBlockNotFoundIfscCodeSubmitFlag = flags =>
  _get(flags, 'blockNotFoundIfscCodeSubmit', defaultBlockNotFoundIfscCodeSubmit) === 'ON';
export const getShowReOpenComplaintFormFlag = flags =>
  _get(flags, 'showReOpenComplaintFormFlag', defaultShowReOpenComplaintFormFlag) === 'ON';
export const getUsps = flags =>
  _get(flags, 'usps', defaultUsps).reduce((acc, usp) => {
    if (acc) {
      if (usp) {
        return `${acc} | ${usp}`;
      }
    } else if (usp) {
      return `${usp}`;
    }
    return acc;
  }, '');
export const getUspsPayment = flags =>
  _get(flags, 'uspsPayment', defaultUsps).reduce((acc, usp) => {
    if (acc) {
      if (usp) {
        return `${acc} | ${usp}`;
      }
    } else if (usp) {
      return `${usp}`;
    }
    return acc;
  }, '');
export const getPaymentMsg = flags => _get(flags, 'paymentMsg', defaultPaymentMsg);

export const getReferralFeatureEnableFlag = flags => _get(flags, 'referralFeatureEnable') === 'ON';
export const getReferrerEnableFlag = flags => _get(flags, 'referrerEnable') === 'ON';
export const getRefereeEnableFlag = flags => _get(flags, 'refereeEnable') === 'ON';
export const getDisplayReferralNewTagFlag = flags => _get(flags, 'displayReferralNewTag') === 'ON';
export const getDisplayAjioWalletNewTagFlag = flags =>
  _get(flags, 'displayAjioWalletNewTag') === 'ON';
export const getDisplayMyRewardsNewTagFlag = flags =>
  _get(flags, 'displayMyRewardsNewTag') === 'ON';
export const getDisplayJioPrimePointsNewTagFlag = flags =>
  _get(flags, 'displayJioPrimePointsNewTag') === 'ON';
export const getDisplayAjioWalletTotalAmountFlag = flags =>
  _get(flags, 'displayAjioWalletTotalAmount') === 'ON';
export const getDisplayNonTransferrableCashLedgerFlag = flags =>
  _get(flags, 'displayNonTransferrableCashLedger') === 'ON';
export const getReferralWidgetPDPEnableFlag = flags =>
  _get(flags, 'referralWidgetPDPEnable') === 'ON';
export const getReferralWidgetWalletEnableFlag = flags =>
  _get(flags, 'referralWidgetWalletEnable') === 'ON';
export const getReferralWidgetThankYouPageEnableFlag = flags =>
  _get(flags, 'referralWidgetThankYouPageEnable') === 'ON';
export const getReferralShareMessage = flags => _get(flags, 'referralShareMessage', '');
export const getReferralWidgetHeading = flags => _get(flags, 'referralWidgetHeading', '');
export const getReferralWidgetSubHeading = flags => _get(flags, 'referralWidgetSubHeading', '');
export const getReferralMyAccountLinkTitle = flags => _get(flags, 'referralMyAccountLinkTitle', '');
export const getReferralMyAccountLinkSubTitle = flags =>
  _get(flags, 'referralMyAccountLinkSubTitle', '');
export const getReferralAuthFeedbackTitle = flags => _get(flags, 'referralAuthFeedbackTitle', '');
export const getReferralAuthFeedbackSubTitle = flags =>
  _get(flags, 'referralAuthFeedbackSubTitle', '');
export const getReferralCongratulationHeading = flags =>
  _get(flags, 'referralCongratulationHeading', '');
export const getReferralCongratulationSubHeading = flags =>
  _get(flags, 'referralCongratulationSubHeading', '');

export const getRuntimeBannersUrlList = flags => _get(flags, 'runtimeBannersUrlList', []);
export const getRuntimeBannersUrlSisList = flags => _get(flags, 'runtimeBannersUrlListSis', []);

export const getRuntimeBannersUrlListMsite = flags => _get(flags, 'runtimeBannersUrlListMsite', []);
export const getRuntimeBannersUrlSisListMsite = flags =>
  _get(flags, 'runtimeBannersUrlListMsiteSis', []);

export const getRuntimeBannersFlag = flags => _get(flags, 'runtimeBanners', 'OFF');
export const getRuntimeBannersSisFlag = flags => _get(flags, 'runtimeBannersSis', 'OFF');

export const getReferralShareUtmParams = flags => _get(flags, 'referralShareUtmParams', {});

export const getReferralCongratsMessageTimer = flags =>
  _get(flags, 'referralCongratsMessageTimer', 0);

export const getCustomerCareEmailResponseTime = flags =>
  _get(flags, 'cc_email_response_time_message', defaultCustomerCareEmailResponseTime);

export const getDisableGSTContentFlag = flags =>
  _get(flags, 'disableGSTContent', defaultDisableGSTContentFlag);

export const getDefaultGSTMessage = flags => _get(flags, 'defaultGSTMessage', defaultGSTMessage);

export const getReturnCapture = flags => _get(flags, 'returnCapture', {});

export const getShowCallMeBackForLuxuryOrder = flags =>
  _get(flags, 'showCallMeBackForLuxuryOrder', defaultShowCallMeBackForLuxuryOrder) === 'ON';

export const getShowCarrierInfo = flags =>
  _get(flags, 'showCarrierInfo', defaultShowCarrierInfo) === 'ON';

export const getOrderFilterFlag = flags =>
  _get(flags, 'orderFilterFlag', defaultOrderFilterFlag) === 'ON';

export const getUseRevampedGoogleAuth = flags =>
  _get(flags, 'revampedGoogleAuth', defaultOrderFilterFlag) === 'ON';

export const getCarrierInfoTimestamp = flags => _get(flags, 'carrierInfoTimestamp', 15);

export const getLuxuryOrderFlag = flags => _get(flags, 'luxuryOrderFlags', defaultLuxuryOrderFlag);

export const getEstimatedWaitTimeCMB = flags =>
  _get(flags, 'estimatedWaitTimeCMB', defaultEstimatedWaitTimeCMB) === 'ON';

export const getShowTimeSlotsCMB = flags =>
  _get(flags, 'showTimeSlotsCMB', defaultShowTimeSlotsCMB) === 'ON';

const defaultDummyCoupons = _get(defaultFlags, 'flags.gameZopCoupons', '');

export const getGameZopCoupons = flags => _get(flags, 'gameZopCoupons', defaultDummyCoupons);
export const getScNextQuestionInSecs = flags =>
  _get(flags, 'showScNextQuestionInSecs', defaultScNextQuestionInSecs);

const defaultTncLink = _get(defaultFlags, 'flags.gamezonetncLink', '');
export const getGameZoneTncLink = flags => _get(flags, 'gamezonetncLink', defaultTncLink);
const defaultTermNCon = _get(defaultFlags, 'flags.tncLinkGame', '');
export const getTermNCon = flags => _get(flags, 'tncLinkGame', defaultTermNCon);
const defaultRuleTermNCon = _get(defaultFlags, 'flags.ruleTncLinkGame', '');
export const getRuleTermNCon = flags => _get(flags, 'ruleTncLinkGame', defaultRuleTermNCon);
export const getHurryMsgInvCap = flags => _get(flags, 'hurryMsgInvCap', defaultHurryMsgInvCap);

const defaultEnableClusterFeatureflag = _get(defaultFlags, 'flags.enableClusterFeature', '');

export const getClusterFeatureFlag = flags =>
  _get(flags, 'enableClusterFeature', defaultEnableClusterFeatureflag) === 'ON';

const defaultEnableClusterFeatureflagHome = _get(
  defaultFlags,
  'flags.enableClusterFeatureHome',
  ''
);

export const getClusterFeatureFlagHome = flags =>
  _get(flags, 'enableClusterFeatureHome', defaultEnableClusterFeatureflagHome) === 'ON';

const dafaultPriceRevealWebFlag = _get(defaultFlags, 'flags.priceRevealWebFlag', '');

export const getPriceRevealWebFlag = flags =>
  _get(flags, 'priceRevealWebFlag', dafaultPriceRevealWebFlag) === 'ON';

const dafaultBatchIdWishlistMobileFlag = _get(defaultFlags, 'flags.batchIdWishlistMobileFlag', '');

export const getBatchIdWishlistMobileFlag = flags =>
  _get(flags, 'batchIdWishlistMobileFlag', dafaultBatchIdWishlistMobileFlag) === 'ON';

const dafaultBatchIdWishlistWebFlag = _get(defaultFlags, 'flags.batchIdWishlistWebFlag', '');

export const getBatchIdWishlistWebFlag = flags =>
  _get(flags, 'batchIdWishlistWebFlag', dafaultBatchIdWishlistWebFlag) === 'ON';

const defaultLuxeFlags = _get(defaultFlags, 'flags.luxeFlags', {
  isThemeEnable: 'ON',
  isFooterEnabled: 'ON',
  isDesktopThemeEnable: 'ON',
  footerData: [
    {
      isEnable: true,
      title: 'Customer Service',
      link: '/selfcare'
    },
    {
      isEnable: true,
      title: 'FAQs',
      link: '/selfcare'
    },
    {
      isEnable: false,
      title: 'Terms & Conditions',
      link: '/help/termsAndCondition'
    },
    {
      isEnable: false,
      title: 'Returns & Refunds policy',
      link: '/return-refund-policy'
    }
  ]
});

const defaultStreetFlags = _get(defaultFlags, 'flags.streetFlags', {
  isThemeEnableMsite: 'OFF',
  isThemeEnableWeb: 'OFF',
  isEmailOptionalMsite: 'OFF',
  isEmailOptionalWeb: 'OFF'
});

export const getLuxeFlags = flags => _get(flags, 'luxeFlags', defaultLuxeFlags);

const defaultPriceRevealV2MobileFeatureFlag = _get(
  defaultFlags,
  'flags.priceRevealV2MobileFeatureFlag',
  ''
);

export const getPriceRevealV2MobileFeatureFlag = flags =>
  _get(flags, 'priceRevealV2MobileFeatureFlag', defaultPriceRevealV2MobileFeatureFlag) === 'ON';

const defaultPriceRevealMobileData = _get(defaultFlags, 'flags.priceRevealMobileData', {});
export const getPriceRevealMobileData = flags =>
  _get(flags, 'priceRevealMobileData', defaultPriceRevealMobileData);

const dafaultPriceRevealV2WebFeatureFlag = _get(
  defaultFlags,
  'flags.priceRevealV2WebFeatureFlag',
  ''
);

export const getPriceRevealV2WebFeatureFlag = flags =>
  _get(flags, 'priceRevealV2WebFeatureFlag', dafaultPriceRevealV2WebFeatureFlag) === 'ON';

const defaultPriceRevealWebData = _get(defaultFlags, 'flags.priceRevealWebData', {});
export const getPriceRevealWebData = flags =>
  _get(flags, 'priceRevealWebData', defaultPriceRevealWebData);

const defaultEarlyAccessFlag = _get(defaultFlags, 'flags.earlyAccessEnabled', '');
export const getEarlyAccessFlag = flags =>
  _get(flags, 'earlyAccessEnabled', defaultEarlyAccessFlag) === 'ON';

const defaultPriceRevealLUXEFlag = _get(defaultFlags, 'flags.priceRevealLUXEFlag', '');
export const getPriceRevealLUXEFlag = flags =>
  _get(flags, 'priceRevealLUXEFlag', defaultPriceRevealLUXEFlag) === 'ON';

const defaultEGiftCardFlag = _get(defaultFlags, 'flags.eGiftCard', '');
export const getEGiftCard = flags => _get(flags, 'eGiftCard', defaultEGiftCardFlag) === 'ON';

const defaultEGiftCardTnCLink = _get(defaultFlags, 'flags.eGiftCardTnCLink', '');
export const getEGiftCardTnCLink = flags =>
  _get(flags, 'eGiftCardTnCLink', defaultEGiftCardTnCLink);

const defaultshowConsentFormForCards = _get(defaultFlags, 'flags.showConsentFormForCards', '');
export const getShowConsentFormForCards = flags =>
  _get(flags, 'showConsentFormForCards', defaultshowConsentFormForCards) === 'ON';

const defaultshowConvertedGifs = _get(defaultFlags, 'flags.showConvertedGifs', '');
export const getShowConvertedGifs = flags =>
  _get(flags, 'showConvertedGifs', defaultshowConvertedGifs) === 'ON';

const defaultAssuredFlag = _get(defaultFlags, 'flags.assuredGifts', '');
export const getAssuredGifts = flags => _get(flags, 'assuredGifts', defaultAssuredFlag) === 'ON';

const defaultAssuredData = _get(defaultFlags, 'flags.assuredGiftsLandingData', {});

export const getAssuredFlags = flags => _get(flags, 'assuredGiftsLandingData', defaultAssuredData);

const defaultAssuredGiftFlags = _get(defaultFlags, 'flags.assuredGiftsFlag', {});
export const getAssuredGiftsFlag = flags =>
  _get(flags, 'assuredGiftsFlag', defaultAssuredGiftFlags);

export const getEarlyAccessData = flags => {
  return flags.earlyAccessEnabled == 'ON' ? _get(flags, 'earlyAccessData', '') : '';
};

export const getEarlyAccessbannerFlagCategory = flags => {
  return flags.earlyAccessBannerCategory == 'ON';
};

export const getAjioMassEmailIdOptionalWeb = flags => {
  return flags?.streetFlags?.isEmailOptionalWeb == 'ON';
};

export const getSelfShipCredit = flags =>
  _get(flags, 'returnCapture.selfShipCredit', defaultSelfShipCredit);

export const getSelfShipMsg = flags => _get(flags, 'returnCapture.selfShipMsg', defaultSelfShipMsg);

export const getShowRecentSearchItemsLimit = flags => _get(flags, 'showRecentSearchItemsLimit', 11);

export const getEnableProductCodeTag = flags => {
  return (flags?.enableProductCodeTag || 'ON') === 'OFF';
};

export const getEnableDeliveryFeeTag = flags => {
  return flags?.enableDeliveryFeeTag === 'ON';
};
export const getStoreWiseDeliveryFeeTags = flags => {
  return flags?.storeWiseDeliveryFeeTags || {};
};

const defaultRetireRCSWallet = _get(defaultFlags, 'flags.retireRCSWallet', false);
export const getRetireRCSWallet = flags =>
  _get(flags, 'retireRCSWallet', defaultRetireRCSWallet);